import React, { useCallback, useContext, useState } from 'react';
import { FaSearchPlus } from 'react-icons/fa';
import { PDFService } from '../pdfService';
import { DialogPDFPreview } from './DialogPDFPreview';
import { useLoading } from '../../../helpers/useLoading';
import { Button } from '../../../components/UI-CHAKRA/Button';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { Spinner } from '../../../components/UI-CHAKRA/Spinner';
import { Portal } from '../../../helpers/Portal';
import { EmissionContext } from '../../../providers/EmissionProvider';
import { get, isEmpty } from 'lodash';
import { usePrescriptionStore } from '../../../stores/prescriptionStore';
import { TrackerEventService } from '../trackerEventService';

interface PDFPreviewProps {
  isSigned: boolean;
}

const previewPDFEventName = 'Consultar prévia PDF';
export function PDFPreview(props: PDFPreviewProps) {
  const { prescription } = usePrescriptionStore();

  const { prescriberConfiguration, emittedTo } = usePrescriptionStore();

  const { showDateInPdf } = useContext(EmissionContext);

  const [loading, runWithLoading] = useLoading();
  const [Modal, setModal] = useState<React.FC | null>(null);

  const { isSigned } = props;

  const disableSelectShowDateInPdf = get(prescriberConfiguration, 'Features.disableSelectShowDateInPdf', false);

  const onPreview = useCallback(() => {
    if (!prescription) return;

    runWithLoading(async () => {
      const { documents } = await PDFService.previewDocuments({
        prescriptionId: prescription.idPrescricao,
        isSigned,
        showDateInPdf: disableSelectShowDateInPdf || showDateInPdf,
        emittedTo,
      });
      const documentsWithTreatmentSummary = documents.filter((document) => document.type === 'TREATMENT_SUMMARY');

      const documentsToShow = isEmpty(documentsWithTreatmentSummary) ? documents : documentsWithTreatmentSummary;

      setModal(() => (
        <Portal>
          <DialogPDFPreview documents={documentsToShow} onClose={() => setModal(null)} />
        </Portal>
      ));

      try {
        await TrackerEventService.track(prescription.idPrescricao, previewPDFEventName);
      } catch (error) {}
    });
  }, [prescription, runWithLoading, isSigned, disableSelectShowDateInPdf, showDateInPdf, emittedTo]);

  return (
    <Box width={'100%'} bg={'#fff'} borderRadius={'7px'} pb={'20px'} display={{ base: 'none', sm: 'flex' }}>
      <>{Modal}</>

      <Button
        width={'100%'}
        onClick={onPreview}
        isDisabled={loading}
        variant={'ghost'}
        bg={'gray.lightest'}
        border={'1px solid'}
        borderColor={'gray.light'}
        fontSize={'13px'}
        h={'32px'}
        borderRadius={'20px'}
        mt={'10px'}
        position={'relative'}
      >
        Prévia da receita
        <Box position={'absolute'} right={'10px'}>
          {!loading ? (
            <FaSearchPlus style={{ marginRight: '5px' }} color={'#343A40'} />
          ) : (
            <Spinner size={'sm'} mr={'5px'} />
          )}
        </Box>
      </Button>
    </Box>
  );
}
